import copy from '../../demo/fixtures/w5/copy.json'
import { useW5Live } from '../analysis/live'
import styles from './AutomationPage.module.css'

export function BenchPosition() {
  const { automation: { benchmark } } = useW5Live()
  return (
    <section className={styles.benchPosition} data-scope="bench-position" lang="zh-CN">
      <div className={styles.sectionHeading}><p>{copy.sections.benchPosition}</p></div>
      <div className={styles.distribution}>
        {benchmark.rows.map((row) => (
          <div className={styles.distributionRow} key={row.metric}>
            <p className={styles.metricLabel}>
              {row.metric}
              <small>你 {row.you} · 中位 {row.median}</small>
            </p>
            <div className={styles.track}>
              <i className={styles.trackBar} />
              <i className={styles.medianMark} style={{ left: '50%' }}><span>中位</span></i>
              <i className={styles.topMark} style={{ left: '78%' }}><span>Top 25%</span></i>
              <i className={styles.youMark} style={{ left: `${row.pct * 100}%` }} />
            </div>
            <p className={styles.position}><strong>{row.position}</strong></p>
          </div>
        ))}
      </div>
    </section>
  )
}
